import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import { Input } from '../common/Form';
import { BrandContact } from '../../contexts/BrandContext';

interface ContactFormModalProps {
  isOpen: boolean;
  contact?: BrandContact | null;
  onCancel: () => void;
  onSubmit: (_data: { firstName: string; lastName: string; title: string; phone: string; email: string }) => void;
}

const ContactFormModal = ({ isOpen, contact, onCancel, onSubmit }: ContactFormModalProps) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [title, setTitle] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');

  const isEdit = !!contact;

  useEffect(() => {
    if (contact) {
      const nameParts = contact.name.split(' ');
      setFirstName(nameParts[0] || '');
      setLastName(nameParts.slice(1).join(' ') || '');
      setTitle(contact.title);
      setPhone(contact.phone);
      setEmail(contact.email);
    } else {
      setFirstName('');
      setLastName('');
      setTitle('');
      setPhone('');
      setEmail('');
    }
  }, [contact]);

  if (!isOpen) {
    return null;
  }

  const handleSubmit = () => {
    onSubmit({ firstName, lastName, title, phone, email });
  };

  return (
    <Modal onOverlayClicked={onCancel}>
      <div className="modal-header">
        <h1 className="modal-title">{isEdit ? 'EDIT CONTACT' : 'ADD CONTACT'}</h1>
      </div>
      <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '24px' }}>
        <div style={{ display: 'flex', gap: '16px' }}>
          <Input
            name="firstName"
            label="FIRST NAME"
            value={firstName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
            className="flex-1"
          />
          <Input
            name="lastName"
            label="LAST NAME"
            value={lastName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
            className="flex-1"
          />
        </div>
        <Input
          name="title"
          label="TITLE"
          value={title}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
        />
        <div style={{ display: 'flex', gap: '16px' }}>
          <Input
            name="phone"
            label="PHONE NUMBER"
            value={phone}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPhone(e.target.value)}
            className="flex-1"
          />
          <Input
            name="email"
            label="EMAIL ADDRESS"
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
            className="flex-1"
          />
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px 20px' }}>
        <button
          type="button"
          onClick={onCancel}
          style={{
            width: '140px',
            height: '40px',
            backgroundColor: 'var(--color-danger)',
            color: 'white',
            borderRadius: '999px',
            border: 'none',
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '1.4px',
            cursor: 'pointer'
          }}
        >
          CANCEL
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          style={{
            width: '140px',
            height: '40px',
            backgroundColor: 'var(--color-accent)',
            color: 'white',
            borderRadius: '999px',
            border: 'none',
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '1.4px',
            cursor: 'pointer'
          }}
        >
          SUBMIT
        </button>
      </div>
    </Modal>
  );
};

export default ContactFormModal;
